<script>

    import {get} from "svelte/store";
    import {publishConfigStore} from "../core/app-store.js";
    import {cartTotalStore} from "../cart/cart-store.js";
    import {onDestroy, onMount} from "svelte";
    import {additionalCostsStore, deliveryStore, removeAdditionalCost} from "./../orders/orders-store.js";
    import {getTotals} from "./../orders/orders.js";
    import {t} from "../core/i18n/language-store.js";

    export let hideTotal = false;
    export let hideDelivery = false;

    const publishConfig = get(publishConfigStore);

    let currency = publishConfig.currency ? ` ${publishConfig.currency}` : '';

    let itemsPrice;
    let deliveryPrice;
    let totalPrice;

    const storeSubscriptions = [
        deliveryStore.subscribe(() => {calculateFinalPrice();}),
        cartTotalStore.subscribe(() => {calculateFinalPrice();})
    ];

    function calculateFinalPrice () {

        const totals = getTotals();

        itemsPrice = totals.itemsPrice;
        deliveryPrice = totals.deliveryPrice;
        totalPrice = totals.totalPrice;
    }

    function removeAdditionalCostHandler (idx) {
        removeAdditionalCost(idx);
        calculateFinalPrice();
    }

    onMount(() => {
        calculateFinalPrice();
    });

    onDestroy(() => {
        for (let i = 0; i < storeSubscriptions.length; i++){
            storeSubscriptions[i]();
        }
    });

</script>

<style>

    ul {
        display: flex;
        flex-direction: column;
        gap: .25rem;
        padding: 1rem 0;
        border-top: 1px dashed #cacacaaa;
        border-bottom: 1px dashed #cacacaaa;
        margin-bottom: 1rem;
    }
    li {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .total-label {

    }
    .total-value {
        padding-left: .5em;
        font-size: 16px;
        font-weight: 500;
    }
    .remove-add-cost-button {
        border-radius: 50%;
        font-family: inherit;
        font-size: inherit;
        font-weight: 400;
    }

    .bold {
        font-weight: 600;
    }
    .final {
        font-size: var(--fs-150);
        font-weight: 600;
    }

</style>

<div>

    {#if (itemsPrice || deliveryPrice || totalPrice)}
        <ul>

            {#if (itemsPrice)}
                <li>
                    <div>
                        {$t('blocks.total.sum')}
                    </div>
                    <div class="bold nowrap">{itemsPrice} {currency}</div>
                </li>
            {/if}

            {#each $additionalCostsStore.items as item, idx}
                <li>
                    <div class="total-label wrap-anywhere">{item.name}</div>

                    {#if item.removable}
                        <div class="flex ai-center gap-05">
                            <div class="total-value nowrap">{item.cost} {currency}</div>
                            <button class="remove-add-cost-button pointer" on:click={() => removeAdditionalCostHandler(idx)}>×</button>
                        </div>
                    {:else}
                        <div class="total-value nowrap">{item.cost} {currency}</div>
                    {/if}
                </li>
            {/each}

            {#if (deliveryPrice && !hideDelivery)}
                <li>
                    <div>
                        {$t('blocks.total.deliveryCost')}
                    </div>
                    <div class="bold nowrap">{deliveryPrice} {currency}</div>
                </li>
            {/if}

            {#if (totalPrice && !hideTotal)}
                <li class="final">
                    <div>
                        {$t('blocks.total.total')}
                    </div>
                    <div class="nowrap">{totalPrice} {currency}</div>
                </li>
            {/if}

        </ul>
    {/if}

</div>
